import React from "react";
import "./TrackingNr.css";

const TrackingNr = (props) => {

  if (props.trackingNr && props.trackingNr.length > 0) {
    let trackingUrl = getTrackingUrl(props.courierId, props.trackingNr, props.trackingUrl);
    return (
      <span className="TrackingNr">
        <a href={trackingUrl} target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}>{props.trackingNr}
        </a>
      </span>
    )
  }

  return (
    <span className="TrackingNr">N/A</span>
  )

}

function getTrackingUrl(courierId, trackingNr, trackingUrl) {
  switch(courierId) {
    case "ups":
    case "ups_v2":
      return `https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${trackingNr}`;
    case "ware2go":
      return trackingUrl;
    case "parcelforce":
      return `http://www.parcelforce.com/track-trace?trackNumber=${trackingNr}`;
    case "royal_mail":
      return `https://www.royalmail.com/track-your-item?trackNumber=${trackingNr}`;
    case "gls":
      return `https://gls-group.eu/EU/en/parcel-tracking?match=${trackingNr}`;
    case "swisspost":
      return `https://www.post.ch/swisspost-tracking?formattedParcelCodes=${trackingNr}`;
    case "hallstein":
      return `https://tracking.hallsteinwater.com/tracking/${trackingNr}`;
    case "byrd":
      return trackingUrl;
    case "planzer":
      return trackingUrl;
    default: 
      return "#"
  }
}

TrackingNr.defaultProps = {
  courierId: "ups",
  trackingNr: ""
}

export default TrackingNr;